import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import DemoPage from "@/pages/DemoPage";
import ApprovePage from "@/pages/ApprovePage";
import ConnectDevicePage from "@/pages/ConnectDevicePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/connect" element={<ConnectDevicePage />} />
        <Route path="/approve" element={<ApprovePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
